/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {isDevelopment} from './env';

// This file is for helpers that should only apply in development builds.
// All logic should be gated a development check!

export function devLog(...args: any[]) {
  if (isDevelopment()) {
    // debug so it's filtered under 'Verbose' in Chrome dev tools and can more
    // easily be toggled on and off for noisiness.
    console.debug(...args);
  }
}
